var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,1H8.5A5.5,5.5,0,0,0,3.313,8.333a.978.978,0,0,0,.1.171A2.965,2.965,0,0,0,3,10v3.343a4.968,4.968,0,0,0,1.464,3.536L6,18.414V22a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V18.414l1.536-1.535A4.968,4.968,0,0,0,21,13.343V6A5.006,5.006,0,0,0,16,1Zm0,20H8V19h8Zm3-7.657a2.983,2.983,0,0,1-.878,2.122L16.586,17H7.414L5.878,15.465A2.983,2.983,0,0,1,5,13.343V10a1,1,0,0,1,2,0v3a1,1,0,0,0,2,0V12h7a1,1,0,0,0,0-2H9A3,3,0,0,0,6,7a2.971,2.971,0,0,0-.932.163A3.478,3.478,0,0,1,8.5,3H16a3,3,0,0,1,3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxe);
export default __webpack_public_path__ + "static/media/boxe.b94ef80c6a4d8d746dfc4fb2131654a3.svg";
export { ForwardRef as ReactComponent };